module.exports = __webpack_public_path__ + "img/map-details.84ac4791.svg";